import { makeStyles } from "@material-ui/core/styles";

export default makeStyles({
  tableContent: {
    margin: "132px 0 114px",
    display: "grid",
    gridTemplateColumns: "290px 1410px",
    overflow: "hidden"
  },
  unitedCell: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "100%",
    fontSize: 12
  },
  gap: {
    gap: 2
  },
  lightGreyCells: {
    backgroundColor: "#f1f3f5"
  },
  mediumGreyCells: {
    backgroundColor: "#e9ecef"
  },
  darkGreyCells: {
    backgroundColor: "#dee2e6"
  }
});
